import React, { useCallback, useEffect, useState } from 'react';
import bemCn from 'bem-cn';
import CookieService from '../../services/cookie.service';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { smartBannerShow } from '../../utils';
import { RouteFormatter } from '../../routes';
import SniffButton from '../sniff-button';
import './top-sticky.scss';

const b = bemCn('sniff-blog-post');

const BlogTopSticky = ({ showAppBanner, useStateSSR }) => {
    const isMobile = useMobileScreen();
    const [showNav, setShowNav] = useState(false);
    const [isShowAppBanner, setIsShowAppBanner] = useState(false);

    let y = typeof window !== 'undefined' ? window.scrollY : 0;

    const scrollTop = useCallback((e) => {
        const window = e.currentTarget;
        if (y < 132 || window.scrollY < 132) {
            setShowNav(false);
        } else if (window.scrollY > 131) {
            setShowNav(true);
        }
        y = window.scrollY;
    });

    useEffect(() => {
        y = window.scrollY;
        window.addEventListener('scroll', scrollTop);
        return () => {
            window.removeEventListener('scroll', scrollTop);
        };
    }, [scrollTop]);

    useEffect(() => {
        if (!isMobile) {
            return;
        }

        if (typeof showAppBanner === 'boolean') {
            setIsShowAppBanner(showAppBanner);
            return;
        }

        const hasCookie = CookieService.get(COOKIE_PARAM_NAME.SNIFF_APP_DOWNLOAD_BANNER);
        const canShowSmartBanner = smartBannerShow();

        if (hasCookie || !canShowSmartBanner || !useStateSSR) {
            return;
        } else {
            setIsShowAppBanner(true);
        }

        const checkCookie = setInterval(() => {
            const hasCookie = CookieService.get(COOKIE_PARAM_NAME.SNIFF_APP_DOWNLOAD_BANNER);
            setIsShowAppBanner(!hasCookie);
        }, 300);

        return () => {
            clearInterval(checkCookie);
        };
    }, [showAppBanner]);

    return (
        <div
            className={b('sticky')
                .mix(showNav ? 'show' : '')
                .mix(isShowAppBanner ? 'has-app-banner' : '')}
        >
            <div className="desktop-container">
                <p className="snif-s1 snif-m1-pc snif-semibold">Rent safe and private dog parks hosted by locals</p>
                <a href={RouteFormatter.listings({})}>
                    <SniffButton className="d-md-none" size="sm">
                        Explore spots
                    </SniffButton>
                    <SniffButton className="d-none d-md-block" size="lg">
                        Explore spots
                    </SniffButton>
                </a>
            </div>
        </div>
    );
};

export default BlogTopSticky;
